import actions from './actions';
import reducers from './reducers';

export const action = actions;
export const reducer = reducers;

const module = {
  action,
  reducer
};

export default module;



// WEBPACK FOOTER //
// ./src/state/modules/events/index.js